import {
  Directive,
  EmbeddedViewRef,
  Input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

@Directive({
  selector: '[appVar]',
})
export class VarDirective<T = unknown> {
  /*
   * Allows arbitrary template variables to be defined.
   *
   * Usage: <ng-container *appVar="myFunction() as functionValue">
   *
   * Adapted from https://stackoverflow.com/a/43172992/8412361
   */

  private _context: AppVarContext<T> = new AppVarContext<T>();
  private _viewRef: EmbeddedViewRef<AppVarContext<T>> | null = null;

  @Input()
  set appVar(context: T) {
    this._context.$implicit = this._context.appVar = context;

    if (!this._viewRef) {
      this._viewRef = this._viewContainer.createEmbeddedView(
        this._templateRef,
        this._context
      );
    }
  }

  // https://github.com/angular/angular/blob/main/packages/common/src/directives/ng_if.ts

  /**
   * Assert the correct type of the expression bound to the `ngIf` input within the template.
   *
   * The presence of this static field is a signal to the Ivy template type check compiler that
   * when the `NgIf` structural directive renders its template, the type of the expression bound
   * to `ngIf` should be narrowed in some way. For `NgIf`, the binding expression itself is used to
   * narrow its type, which allows the strictNullChecks feature of TypeScript to work with `NgIf`.
   */

  // tslint:disable
  static ngTemplateGuard_appVar: 'binding';
  // tslint:enable

  /**
   * Asserts the correct type of the context for the template that `NgIf` will render.
   *
   * The presence of this method is a signal to the Ivy template type-check compiler that the
   * `NgIf` structural directive renders its template with a specific context type.
   */

  // Passing down variable Type
  static ngTemplateContextGuard<T>(
    dir: VarDirective<T>,
    ctx: any
  ): ctx is AppVarContext<T> {
    return true;
  }

  constructor(
    private _viewContainer: ViewContainerRef,
    private _templateRef: TemplateRef<AppVarContext<T>>
  ) {}
}

export class AppVarContext<T = unknown> {
  // tslint:disable
  public $implicit: T = null!;
  public appVar: T = null!;
  // tslint:enable
}
